import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ActivityCustomValuesList } from "PFApp/components/custom_values_list";
import { useActivityNameAndId } from "PFCore/helpers/activities";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./content.module.scss";
import { Description } from "./description";

export type EngagementContentProps = {
  activity: Activity;
  isFeed?: boolean;
};

export const EngagementContent = ({ activity, isFeed }: EngagementContentProps) => {
  const { t } = useTranslation();
  const getRoleNameId = useActivityNameAndId();
  const { name, id } = getRoleNameId(activity);

  const brands = activity.custom_fields.find((item) => item.type.name === "brands");

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={activity} profile={activity.profile}>
        <div className={css.header}>
          <h3>{name}</h3>
          {id && <div>{t("id", { id })}</div>}
        </div>
        <div className={css.description}>
          <Description description={activity.description} />
        </div>
        {brands && (
          <ActivityCustomValuesList
            customFieldName="brands"
            customValues={brands.values}
            activityId={activity.id}
            maxNameLength={isFeed ? 25 : undefined}
          />
        )}
      </ActivityPreviewLink>
    </div>
  );
};
